import { Link2, Activity, Sparkles } from "lucide-react";
import { SectionWrapper } from "@/components/ui/section-wrapper";

const steps = [
  {
    number: "1",
    icon: Link2,
    title: "Connect in minutes",
    description: "Link your WooCommerce store. We guide you through the API setup.",
  },
  {
    number: "2",
    icon: Activity,
    title: "See what's broken",
    description: "Your assistant analyzes everything and shows a prioritized fix list.",
  },
  {
    number: "3",
    icon: Sparkles,
    title: "Ask or automate",
    description: "Chat to take action, or let AI bulk-fix issues for you to review.",
  },
];

export function HowItWorksSection() {
  return (
    <SectionWrapper variant="muted">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          Up and running in 3 minutes
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          No complicated setup. No technical knowledge required.
        </p>
      </div>

      <div className="relative">
        {/* Connection line */}
        <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary/30 to-transparent -translate-y-1/2 z-0" />

        <div className="grid md:grid-cols-3 gap-8 relative z-10">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative inline-flex mb-6">
                <div className="h-20 w-20 rounded-full bg-card border-2 border-primary flex items-center justify-center shadow-lg shadow-primary/20">
                  <step.icon className="h-8 w-8 text-primary" />
                </div>
                <span className="absolute -top-2 -right-2 h-8 w-8 rounded-full bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center">
                  {step.number}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {step.title}
              </h3>
              <p className="text-muted-foreground">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
